import React from 'react';
import {Doughnut} from "react-chartjs-2";

import {
    chart1_2_options,
    chartExample3,
    doughnut_options
} from "variables/charts.js";

class SystemSizeChart extends React.Component {
    constructor(props) {
        super(props);
        this.salesChart = {
            all: canvas => {
                let ctx = canvas.getContext("2d");

                return {
                    labels: this.getLabels(),
                    datasets: [
                        {
                            label: "All Appointments",
                            fill: true,
                            backgroundColor: [
                                'rgba(169, 50, 38, 0.5)',
                                'rgba(136, 78, 160 , 0.5)',
                                'rgba(46, 134, 193, 0.5)',
                                'rgba(23, 165, 137, 0.5)',
                            ],
                            borderColor: [
                                'rgba(169, 50, 38, 1)',
                                'rgba(136, 78, 160 , 1)',
                                'rgba(46, 134, 193, 1)',
                                'rgba(23, 165, 137, 1)',
                            ],
                            borderWidth: 2,
                            borderDash: [],
                            borderDashOffset: 0.0,
                            pointBackgroundColor: "#1f8ef1",
                            pointBorderColor: "rgba(255,255,255,0)",
                            pointHoverBackgroundColor: "#1f8ef1",
                            pointBorderWidth: 20,
                            pointHoverRadius: 4,
                            pointHoverBorderWidth: 15,
                            pointRadius: 4,
                            data: this.getData()
                        }
                    ]
                };
            },
            options: doughnut_options
        };
    }

    getLabels = () => {
        return ["0+", "5+", "8+", "10+"];
    }

    getData = () => {
        var d = [0, 0, 0, 0];
        this.props.data.forEach(di => {
            var doublenumber = Number(di.SystemSize.replace(/[^0-9\.]+/g,""));
            if (doublenumber >= 10) {
                d[3]++;
            } else if (doublenumber >= 8) {
                d[2]++;
            } else if (doublenumber >= 5) {
                d[1]++;
            } else {
                d[0]++;
            }
        });
        return d;
    }

    render() {
        return (
            <>
                {this.props.data.length > 0 &&
                <Doughnut
                    data={this.salesChart.all}
                    options={doughnut_options}
                />
                }
            </>
        )
    }
}

export default SystemSizeChart;